const getBrowserCountryCode = () => {
  if (typeof navigator === "undefined") return null;
  const languages = navigator.languages?.length
    ? navigator.languages
    : [navigator.language];
  const localeWithRegion = languages.find(locale =>
    /^[a-z]{2,3}[-_][a-z]{2}$/i.test(locale || "")
  );
  if (!localeWithRegion) return null;
  return localeWithRegion
    .split(/[-_]/)
    .pop()
    .toUpperCase();
};

export { getBrowserCountryCode };
